// Constant giới hạn của Number
export default {
    MaxPercentage: 100,
    ZeroPercentage: 0,
};
